// Travel & Location Policy — mirrors backend routes/pricing_catalog.py (backend is the price authority).
import axios from "axios";

// Code fallback — the live table is Studio-editable via GET /api/travel-zones.
export const TRAVEL_ZONES = [
    { id: "klang", label_en: "Port Klang / Klang", label_cn: "巴生港 / 巴生", fee_rm: 0, mode: "fixed", kv: true },
    { id: "shah-alam", label_en: "Shah Alam / Setia Alam", label_cn: "莎阿南 / 实达阿南", fee_rm: 30, mode: "fixed", kv: true },
    { id: "subang-pj", label_en: "Subang Jaya / Puchong / Petaling Jaya", label_cn: "梳邦再也 / 蒲种 / 八打灵再也", fee_rm: 50, mode: "fixed", kv: true },
    { id: "kl", label_en: "Kuala Lumpur", label_cn: "吉隆坡", fee_rm: 80, mode: "fixed", kv: true },
    { id: "outside-kv", label_en: "Outside Klang Valley", label_cn: "巴生谷以外", fee_rm: null, mode: "quote", kv: false },
    { id: "tbc", label_en: "To be confirmed", label_cn: "待确认", fee_rm: null, mode: "tbc", kv: false },
];

export async function fetchTravelZones() {
    try {
        const r = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/travel-zones`, { timeout: 8000, params: { _t: Date.now() } });
        const zones = Array.isArray(r.data?.zones) ? r.data.zones : [];
        return zones.length ? zones : TRAVEL_ZONES;
    } catch {
        return TRAVEL_ZONES;
    }
}

export const PRICE_FOOTNOTE = {
    en: "Travel charges may apply based on the confirmed filming location. Toll, parking, accommodation, location fees and transportation between multiple locations are charged separately.",
    cn: "旅程费用视确认的拍摄地点而定。过路费、停车费、住宿、场地费用及多地点之间的交通费另行收取。",
};

export const TRAVEL_TBC_MESSAGE = {
    en: "Travel charges will be confirmed by Kaily before the production booking is finalised.",
    cn: "旅程费用将由 Kaily 在拍摄预订最终确认前与你确认。",
};

export function zoneLabel(zone, lang) {
    return lang === "cn" ? zone.label_cn : zone.label_en;
}

// → { travel_rm, status: "included" | "charged" | "tbc" }
export function travelQuote(zoneId, pkg, zones = TRAVEL_ZONES) {
    const zone = zones.find((z) => z.id === zoneId);
    if (!zone) return null;
    if (zone.mode !== "fixed") return { travel_rm: 0, status: "tbc" };
    if (pkg?.travel_included_kv && zone.kv) return { travel_rm: 0, status: "included" };
    const fee = Number(zone.fee_rm || 0);
    return { travel_rm: fee, status: fee === 0 ? "included" : "charged" };
}

export function formatRm(n) {
    return `RM ${Number(n || 0).toLocaleString("en-MY")}`;
}
